var React = require('react');

function Cz (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v240H0z","key":0}),React.createElement("path",{"fill":"#d7141a","d":"M0 240h640v240H0z","key":1}),React.createElement("path",{"fill":"#11457e","d":"M360 240 0 0v480z","key":2})]);
}

Cz.defaultProps = {"id":"flag-icons-cz","viewBox":"0 0 640 480"};

module.exports = Cz;

Cz.default = Cz;
